import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const AlignRight: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['line', { x1: '21', x2: '3', y1: '6', y2: '6' }],
    ['line', { x1: '21', x2: '9', y1: '12', y2: '12' }],
    ['line', { x1: '21', x2: '7', y1: '18', y2: '18' }],
  ],
];

export default AlignRight;
